// extracted by mini-css-extract-plugin
module.exports = {"showbox":"loading2_showbox__3fcKX","loader":"loading2_loader__2IsV9","hide":"loading2_hide__3MDgP"};